export default {
  state: () => ({
    filters: [
      {
        name: "Estado da ordem",
        slug: "alg_ord_state",
        type: "tagbox",
        values: [
          {
            name: "Nova",
            value: "NEW",
          },
          {
            name: "Ativa",
            value: "ACTIVE",
          },
          {
            name: "Finalizada",
            value: "STOPPED",
          },
          {
            name: "Executada",
            value: "FILLED",
          },
          {
            name: "Rejeitada",
            value: "REJECTED",
          },
          {
            name: "Expirada",
            value: "EXPIRED",
          },
        ],
        active: [],
      },
      {
        datePeriod: {
          name: "Período",
          slug: "date_period",
          start: "",
          end: "",
        },
      },
    ],
  }),

  getters: {
    getFilters(state) {
      return state.filters.filter((item) => item.slug !== "date_period");
    },
    getActiveFilters(state) {
      return state.filters.find((item) => item.slug === "alg_ord_state").active;
    },
    getDatePeriod(state) {
      return state.filters.find((item) => item.slug === "date_period");
    },
  },

  mutations: {
    SET_FILTER: (state, { slug, value }) => {
      let activeFilters = state.filters.find((item) => item.slug === slug).active;
      if (activeFilters.includes(value)) {
        activeFilters.splice(
          activeFilters.findIndex((item) => item === value),
          1
        );
      } else {
        activeFilters.push(value);
      }
    },
    CLEAR_ACTIVE_FILTERS: (state) => {
      // console.log("clear filters");
      state.filters.forEach((filter) => {
        if (filter.hasOwnProperty("active")) {
          filter.active = [];
        } else if (filter.slug === "date_period") {
          filter.start = "";
          filter.end = "";
        }
      });
    },
  },

  actions: {
    setFilter: ({ commit }, { slug, value }) => {
      commit("SET_FILTER", { slug, value });
    },
    clearActiveFilters: ({ commit }) => {
      commit("CLEAR_ACTIVE_FILTERS");
    },
  },

  namespaced: true,
};
